import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { CriticsService } from 'src/app/shared/services/core/critics.service';

@Component({
  selector: 'app-criticas',
  imports: [TegelModule, CommonModule],
  templateUrl: './criticas.component.html',
  styleUrl: './criticas.component.scss'
})
export class CriticasComponent implements OnInit {
  critics: any[];
  page = 1;
  searchText = '';
  order = "id";

  constructor(private utilService: UtilService,
              private dialogService: DialogService,
              private criticsService: CriticsService,
              private toastr: ToastrService
  ){
    this.critics = [];
  }

  ngOnInit(): void {
    this.getAllCriticals();
  }

  getAllCriticals() {
    this.criticsService.get().subscribe((result) => {
      if (result) {
        this.critics = result;
      }
    });
  }

  deleteCritic(id: any){
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar', 
      message: 'Deseja excluir a crítica ' + id + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed){
        this.criticsService.delete(id).subscribe((result) => {
          if (result && !result.hasErrors) {
            let index = 0;
            do { 
              index = this.critics.findIndex(c => c.id === id);
              if (index > -1){
                this.critics.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  // openSaveCritic(critic = new Critic()) {
  //   this.dialogService.addDialog(SaveCriticComponent, {
  //     critic: critic
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //       if(result && result.success){
  //         this.getAllCriticals();
  //         this.toastr.success('Registro salvo.', 'Sucesso');
  //       }
  //   });
  // }


}
